import { render, staticRenderFns } from "./VCardProposta.vue?vue&type=template&id=4c3de91a"
import script from "./VCardProposta.vue?vue&type=script&lang=js"
export * from "./VCardProposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports